var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-site-layout ppf-bg-purple"},[_c('app-busy-overlay',{attrs:{"fullScreen":true}}),_c('app-menu'),_c('app-header'),_c('app-body'),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }